"use strict";

exports.__esModule = true;
exports.validateComment = exports.EditTicketComment = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var validateComment = exports.validateComment = function validateComment(value) {
  if (!value || !value.trim()) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TicketDetailsPage.commentError",
      defaultMessage: "Comment is required."
    });
  }
};
var EditTicketComment = exports.EditTicketComment = function EditTicketComment(props) {
  var _props$ticketComment = props.ticketComment,
    handleCancelCommentEdit = _props$ticketComment.handleCancelCommentEdit,
    handleCommentEdit = _props$ticketComment.handleCommentEdit,
    comment = _props$ticketComment.comment;
  var handleSubmit = function handleSubmit(values) {
    return handleCommentEdit(comment.id || comment, values.comment);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    onSubmit: handleSubmit,
    initialValues: {
      comment: comment.body
    }
  }, function (_ref) {
    var handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      invalid = _ref.invalid,
      submitting = _ref.submitting;
    return /*#__PURE__*/_react["default"].createElement("form", {
      "data-testid": "EditCommentForm",
      onSubmit: function onSubmit(event) {
        return handleSubmit(event);
      },
      style: {
        display: "flex",
        flexDirection: "column",
        padding: "5px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
      name: "comment",
      validate: validateComment
    }, function (_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        intent: meta.error ? _core.Intent.DANGER : _core.Intent.NONE,
        helperText: meta.error ? meta.error : ""
      }, /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        "data-testid": "EditCommentTextArea"
      }, input, {
        fill: true
      })));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        maxWidth: "200px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      style: {
        marginRight: "5px"
      },
      type: "submit",
      intent: _core.Intent.PRIMARY,
      loading: submitting,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Ticketing.Update",
        defaultMessage: "Update"
      }),
      disabled: pristine || invalid
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      onClick: handleCancelCommentEdit,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Ticketing.Cancel",
        defaultMessage: "Cancel"
      })
    })));
  });
};